// 1. http / https / www links
const LINK_REGEX_HTTP = /(https?:\/\/|www\.)[^\s]+/i;
// 2. domain-like links (but NOT emails)
const LINK_REGEX_DOMAIN =
  /(^|[^a-z0-9@_.-])([a-z0-9-]+(\.|%2[eE]))+[a-z]{2,24}(\/[^\s]*)?/i;
// 3. specific encoded or normal "/treatwell"
const LINK_REGEX_TREATWELL = /(\/|%2[fF])treatwell/i;

export function appointmentNoteHasSuspiciousLink(
  notes?: string | null,
  isTreatwell?: boolean | null,
): boolean {
  if (!isTreatwell || !notes) return false;
  return (
    LINK_REGEX_HTTP.test(notes) ||
    LINK_REGEX_DOMAIN.test(notes) ||
    LINK_REGEX_TREATWELL.test(notes)
  );
}
